"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_STYLES = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = require("styled-components");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    min-height: 2.5em;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var INPUT_STYLES = (0, _styledComponents.css)(_templateObject());
exports.INPUT_STYLES = INPUT_STYLES;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/inputs/constants.js
// module id = 364
// module chunks = 209 210 211 212